import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import App from './App';
import reducer, { initialState } from "./reducer.js";
import { StateProvider } from "./StateProvider.js";

ReactDOM.render(
  <React.StrictMode>
    <StateProvider initialState={initialState} reducer={reducer}>
      <App />
    </StateProvider>
  </React.StrictMode>,
  document.getElementById("root")
);